const queryString = require('query-string');

export const SearchURLGenerator = (filtersObject) => queryString.stringify({ ...filtersObject }, { arrayFormat: 'comma' })




